// ---------- Start: MODIFIED NEWS COMPONENT THAT WORKS WITH LOCAL json FILES ----------
import React, { useEffect, useState } from 'react';
import NewsItem from './NewsItem';
import Spinner from './Spinner';
import PropTypes from 'prop-types';

const News = (props) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalResults, setTotalResults] = useState(0);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const updateNews = () => {
    props.setProgress(10);
    const jsonData = require(`../json_${props.category}.json`); // Load the corresponding JSON file
    const { articles, totalResults } = jsonData;
    setArticles(articles);
    setTotalResults(totalResults);
    setLoading(false);
    props.setProgress(100);
  };

  useEffect(() => {
    document.title = `${capitalizeFirstLetter(props.category)} - NewsMonkey`;
    updateNews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.category]);

  return (
    <>
      <h1 className="text-center" style={{ margin: '35px 0px', marginTop: '90px' }}>
        NewsMonkey - Top <b>{capitalizeFirstLetter(props.category)}</b> Headlines
      </h1>
      {loading && <Spinner />}
      <div className="container">
        <div className="row">
          {articles.map((element) => (
            <div className="col-md-4" key={element.url}>
              <NewsItem
                title={element.title}
                description={element.description}
                imageUrl={element.urlToImage}
                newsUrl={element.url}
                author={element.author}
                date={element.publishedAt}
                source={element.source.name}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

News.propTypes = {
  category: PropTypes.string,
  setProgress: PropTypes.func,
};

export default News;
// ---------- End: MODIFIED NEWS COMPONENT THAT WORKS WITH LOCAL json FILES ----------

// ---------- Start: OLD NEWS COMPONENT THAT WORKS WITH NEWSAPI.ORG ----------
// import React, { useEffect, useState } from 'react'
// import NewsItem from './NewsItem'
// import Spinner from './Spinner';
// import PropTypes from 'prop-types';
// import InfiniteScroll from 'react-infinite-scroll-component';

// const News = (props) => {
//   const [articles, setArticles] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [page, setPage] = useState(1)
//   const [totalResults, setTotalResults] = useState(0)



//   const capitalizeFirstLetter = (string) => {
//     return string.charAt(0).toUpperCase() + string.slice(1);
//   }

//   const updateNews= async () => {
//     props.setProgress(10);
//     const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page}&pageSize=${props.pageSize}`;
//     setLoading(true)
//     let data = await fetch(url);
//     props.setProgress(30);
//     let parsedData = await data.json();
//     props.setProgress(70);
//     setArticles(parsedData.articles);
//     setTotalResults(parsedData.totalResults);
//     setLoading(false);
//     props.setProgress(100);
//   }

//   useEffect(() => {
//     document.title = `${capitalizeFirstLetter(props.category)} - NewsMonkey`;
//     updateNews();
// // eslint-disable-next-line
//   }, [])

//   const fetchMoreData = async () => {
//     const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page+1}&pageSize=${props.pageSize}`;
//     setPage(page + 1);
//     let data = await fetch(url);
//     let parsedData = await data.json();
//     setArticles(articles.concat(parsedData.articles))
//     setTotalResults(parsedData.totalResults);
//   }


//   return (
//     <>
//       <h1 className="text-center" style={{margin: "35px 0px", marginTop: "90px"}}>NewsMonkey - Top <b>{capitalizeFirstLetter(props.category)}</b> Headlines</h1>
//       {loading && <Spinner/>}
//       <InfiniteScroll
//         dataLength={articles.length}
//         next={fetchMoreData}
//         hasMore={articles.length < totalResults}
//         loader={<Spinner/>}
//       >
      
//       <div className="container">
//         <div className="row">
//           {articles.map((element)=>{
//             return <div className="col-md-4" key={element.url}>
//             <NewsItem title={element.title} description={element.description} imageUrl={element.urlToImage} newsUrl={element.url} author={element.author} date={element.publishedAt} source={element.source.name}/>
//             </div>
//           })}
//         </div>
//       </div>
//       </InfiniteScroll>
//     </>
//   )
// }

// News.defaultProps = {
//   country: 'us',
//   pageSize: 8,
//   category: "general"
// }

// News.propTypes = {
//   country: PropTypes.string,
//   pageSize: PropTypes.number,
//   category: PropTypes.string
// }

// export default News
// ---------- End: OLD NEWS COMPONENT THAT WORKS WITH NEWSAPI.ORG ----------